import {useState} from "react";
import Input from 'components/input/input';

import PopInfo from "components/info-popup/pop-info";
import Select from "components/select/select";
import CreatableSelect from "components/select/creatable";

const MilestoneOnBoarding = ({t, state, setState = ()=>{},
                        categoriesOptions,positionOptions,errorMessages,
                        createCategory, createPosition

})=>{

    const [url, setUrl] = useState(null);
    const year = 2099;

    
    const handleInputChange = async (e,index) => {
        const { name, value } = e.target;
    
        if (name === "category" && value?.__isNew__) {
            const data = await createCategory(value);
            const updatedMilestones = [...state.milestones];
            updatedMilestones[index][name] = { label: data.name, value: data.id };
            setState((prev) => ({
                ...prev,
                milestones: updatedMilestones
            }));
            return;
        }else if(name === "position" && value?.__isNew__){ 
            const data = await createPosition(value);
            const updatedMilestones = [...state.milestones];
            updatedMilestones[index][name] = { label: data.name, value: data.id };
            setState((prev) => ({
                ...prev,
                milestones: updatedMilestones
            }));
            return;
        }

        if(name === "year" && value.length > 4) {
            return e.preventDefault();
        }
        const updatedMilestones = [...state.milestones];
        updatedMilestones[index][name] = value;

        setState((prev) => ({
            ...prev,
            milestones: updatedMilestones
        }));
    };

    const showMediaHandle = (url=null)=>{
        setUrl(url);
    }

    const setMinYear = (e,index) =>{ 
    const { name, value } = e.target;
        if(e.target?.min && parseInt(e.target?.min) > parseInt(value)){
        const updatedMilestones = [...state.milestones];
        updatedMilestones[index][name] = e.target.min;
        setState((prev) => ({
            ...prev,
            milestones: updatedMilestones
        }));
        return;
        }
  }


    return(
        <div className="px-2">
            {
                state?.milestones.map((item,index)=>{
                    return <div key={index} className="mb-2">
                        <h1 className="font-semibold text-md flex gap-2 items-center">
                            <>Milestone {index+1}</>
                            {
                                index === 0 && <PopInfo type={'milestones_not_login'} showMediaHandle={showMediaHandle}/>
                            }
                        </h1>
                        <Input
                            inputContainerClass="mb-1"
                            value={item.title}
                            name="title"
                            outsideLabel={t("title")}
                            placeholder={t("starWars")}
                            outsideLabelClass={`text-sm font-bold text-darkerGray ${index < 1 ? 'marked' : ''}`}
                            noLabelPaddingY="0.8rem"
                            type="text"
                            onChange={(e)=>{handleInputChange(e,index)}}
                            errorMessagePosition="bottom"
                            errorMessage={errorMessages[index]?.title}
                            formContainer="mb-1"
                            
                            />
                        <div className="flex flex-wrap w-full flex-col gap-0 md:gap-2 md:flex-row">
                            <div className="flex-1">
                                <CreatableSelect
                                    label={`${t('position')} (eg. Actor)`}
                                    options={positionOptions.sort((a, b) => a.label.localeCompare(b.label))}
                                    placeholder={t('pleaseSelect')}
                                    name="position"
                                    height={58}
                                    value={
                                        item?.position?.value &&
                                        positionOptions.filter((g) => g.value === item?.position?.value)
                                    }
                                    onChange={(e) =>
                                    handleInputChange({
                                        target: { name: "position", value: e },
                                    },index)
                                    }
                                    errorMessage={errorMessages[index]?.position}
                                    labelClass={`text-sm font-bold text-darkerGray leading-4 ${index < 1 ? 'marked' : ''}`}
                                    formContainer="mb-1"
                                />
                            </div>  
                            <div className="flex-1">
                                <CreatableSelect
                                    label={`${t('Category')} (eg. Film)`}
                                    options={categoriesOptions}
                                    placeholder={t('pleaseSelect')}
                                    name="category"
                                    height={58}
                                    value={
                                        item?.category?.value &&
                                        categoriesOptions.filter((g) => g.value === item?.category?.value)
                                    }
                                    onChange={(e) =>
                                    handleInputChange({
                                        target: { name: "category", value: e },
                                    },index)
                                    }
                                    errorMessage={errorMessages[index]?.category}
                                    labelClass={`text-sm font-bold text-darkerGray leading-4 ${index < 1 ? 'marked' : ''}`}
                                    formContainer="mb-1"
                                />
                            </div>
                            <div className="flex-1">
                                <Input
                                    min="1900"
                                    max={`${year}`}
                                    value={item?.year || ""}
                                    name='year'
                                    placeholder={t('year')}
                                    outsideLabel={t("year")}
                                    inputClass="border border-borderGray rounded-md"
                                    outsideLabelClass={`text-sm font-bold text-darkerGray ${index < 1 ? 'marked' : ''}`}
                                    noLabelPaddingY="1rem"
                                    type="number"
                                    onChange={(e)=>{handleInputChange(e,index)}}
                                    errorMessagePosition="bottom"
                                    disableUpDownArrow={true}
                                    onWheel={(e)=>e.target.blur()}
                                    onBlur={(e)=>setMinYear(e,index)}
                                    maxLength={4}
                                    errorMessage={errorMessages[index]?.year}
                                    formContainer="mb-1"
                                />  
                            </div>
                        </div>
                    </div>
                })
            }

                                

        </div>
    )
}

export default MilestoneOnBoarding;